/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export function Debounce(delay:number = 300): MethodDecorator {
  return function(target: any, propertyKey: string, descriptor: PropertyDescriptor): PropertyDescriptor {
    let timeout = null;
    const original = descriptor.value;
    descriptor.value = function (...args: any): void {
      clearTimeout(timeout);
      timeout = setTimeout(() => original.apply(this, args), delay);
    };
    return descriptor;
  };
}
